import OwnerType from '../ownerType';
export default class Stock extends OwnerType {
  constructor() {
    super();
    this.id = 'stock';
    this.name = "Aksjebolig";
    this.icon = "mdi-account-box-multiple";
  }
}